import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../../test-utils/html-validate";

describe("uic-accordion", () => {
    it("allows only one expanded item in mode 'single' ", async () => {
        const { page, accordion, accordionItem1, accordionItem2 } = await setupTest();

        await accordion.setProperty("mode", "single");

        await accordionItem1.click();
        await page.waitForChanges();

        await accordionItem2.click();
        await page.waitForChanges();

        expect(await accordionItem1.getProperty("open")).toEqual(false);
        expect(await accordionItem2.getProperty("open")).toEqual(true);
    });

    it("allows multiple expanded items in mode 'multiple' ", async () => {
        const { page, accordion, accordionItem1, accordionItem2 } = await setupTest();

        await accordion.setProperty("mode", "multiple");

        await accordionItem1.click();
        await page.waitForChanges();

        await accordionItem2.click();
        await page.waitForChanges();

        expect(await accordionItem1.getProperty("open")).toEqual(true);
        expect(await accordionItem2.getProperty("open")).toEqual(true);
    });

    it("should render valid html", async () => {
        await testValidHtml(`
            <uic-accordion>
                <uic-accordion-item id="1"></uic-accordion-item>
                <uic-accordion-item id="2"></uic-accordion-item>
            </uic-accordion>
        `);
    });
});

async function setupTest() {
    const page = await newE2EPage({
        html: `
        <uic-accordion>
            <uic-accordion-item id="1"></uic-accordion-item>
            <uic-accordion-item id="2"></uic-accordion-item>
        </uic-accordion>
        `
    });

    const accordion = await page.find("uic-accordion");
    const accordionItem1 = await page.find("[id='1']");
    const accordionItem2 = await page.find("[id='2']");

    return { accordion, accordionItem1, page, accordionItem2 };
}
